export default {
  computed: {
    hasAuthorize() {
      const list = this.$store.getters["getAuthorizeList"];
      const activeUser = this.$store.getters["getActiveUser"];
      const controller = "Batteries";
      if (activeUser.userInfo.role === "Admin")
        return {
          list: true,
          add: true,
          edit: true,
          delete: true,
          getById: true,
          calculate: true,
          locked: true,
        };
      return {
        list: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "GetAll"
        ),
        add: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "Create"
        ),
        calculate: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "Calculate"
        ),
        edit: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "Update"
        ),
        delete: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "Delete"
        ),
        getById: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "GetById"
        ),
        locked: !list.some(
          (item) =>
            item.authorityInfo.controller === controller &&
            item.authorityInfo.action === "UpdateLockStatus"
        ),
      };
    },
  },
};
